import { pageView } from 'Site/js/util/analytics';
import store from 'Site/js/store';
import VueRouter from 'vue-router';

import FollowPanel from 'Profile/component/FollowPanel.vue';
import Profile from 'Profile/component/Profile.vue';
import ProfileAdverts from 'Profile/component/ProfileAdverts.vue';
import ProfileEbooks from 'Profile/component/ProfileEbooks.vue';
import ProfileFriends from 'Profile/component/ProfileFriends.vue';
import ProfileMedia from 'Profile/component/ProfileMedia.vue';
import ProfilePlaceholder from 'Profile/component/ProfilePlaceholder.vue';
import ProfileStatuses from 'Profile/component/ProfileStatuses.vue';

let firstPage = true;

const routerConfig = store.state.config && store.state.config.data && store.state.config.data.router ? store.state.config.data.router : { parts: {} };
const router = new VueRouter({
    mode: 'history',
    linkExactActiveClass: 'active',
    routes: [
        { name: 'adverts', path: `${routerConfig.adverts}`, component: ProfileAdverts },
        { name: 'ebooks', path: `${routerConfig.ebooks}`, component: ProfileEbooks },
        { name: 'events', path: `${routerConfig.events}`, component: ProfilePlaceholder },
        {
            name: 'following',
            path: `${routerConfig.following}(/${routerConfig.parts.page}/)?:page?`,
            component: FollowPanel,
            props: {
                followType: 'following'
            }
        },
        {
            name: 'followers',
            path: `${routerConfig.followers}(/${routerConfig.parts.page}/)?:page?`,
            component: FollowPanel,
            props: {
                followType: 'followers'
            }
        },
        { name: 'friends', path: `${routerConfig.friends}(/${routerConfig.parts.page}/)?:page?`, component: ProfileFriends },
        { name: 'groups', path: `${routerConfig.groups}`, component: ProfilePlaceholder },
        { name: 'mediaAlbum', path: `${routerConfig.photos}/${routerConfig.parts.album}/:album`, component: ProfileMedia },
        {
            name: 'mediaUpload',
            path: `${routerConfig.photos}/${routerConfig.parts.upload}`,
            component: ProfileMedia,
            props: { showUpload: true }
        },
        { name: 'media', path: `${routerConfig.photos}`, component: ProfileMedia },
        { name: 'statuses', path: `${routerConfig.statuses}`, component: ProfileStatuses },
        { name: 'status', path: `${routerConfig.status}/:postId`, component: ProfilePlaceholder },
        { name: 'stories', path: `${routerConfig.stories}(/${routerConfig.parts.page}/)?:page?`, component: ProfilePlaceholder },
        { path: `${routerConfig.view}`, name: 'view', component: Profile }
    ]
});

router.afterEach((to) => {
    document.querySelector('.profile-nav-toggle').classList.add('collapsed');
    const $nav = document.querySelector('#collapseProfileNav');
    $nav.classList.add('collapsing');
    $nav.style.height = `${$nav.offsetHeight}px`;
    setTimeout(() => {
        $nav.style.height = '0px';
    }, 50);
    setTimeout(() => {
        $nav.classList.remove('in');
        $nav.classList.remove('collapsing');
    }, 300);
    if (!firstPage) {
        pageView(`${window.location.origin}${to.path}`);
    }
    firstPage = false;

    const $active = $nav.querySelector('.active');
    if (['groups', 'events', 'stories'].indexOf(to.name) === -1 && $active) {
        $active.classList.remove('active');
    }
});

export default router;
